import { Locale } from '@doordash/lib-i18n'
import i18n from '../..'
import { setLocaleToCookie } from '../../lib'
import getIsURLLocalizableRoute from '../getIsURLLocalizableRoute'
import getLocalizedUrl from '../getLocalizedUrl'

/**
 * This function act when user change Locale
 *
 * @param {Locale} nextLocale - Locale to change
 *
 * if route is a URLLocalizableRoutes, update cookie and localized URL with nextLocale
 * else just fallback to defaul behavior
 */
const changeLocaleToSources = (nextLocale: Locale) => {
  try {
    if (getIsURLLocalizableRoute(window.location.pathname)) {
      setLocaleToCookie(nextLocale)
      window.location.href = getLocalizedUrl(window.location, nextLocale)
    } else {
      // Fallback to defaul behavior https://www.i18next.com/overview/api#changelanguage
      // https://github.com/doordash/web/blob/master/packages/lib-i18n/src/i18nAppProvider.ts#L109
      i18n.i18nextInstance.changeLanguage(nextLocale).then(() => {
        window.location.reload()
      })
    }
  } catch (e) {
    console.warn(`Unable to change to locale ${nextLocale}`)
  }
}

export default changeLocaleToSources
